import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { cn, IconButton } from '@c2fo/liquidity';
import { XmarkIcon } from '@c2fo/liquidity/icons';

interface FilterDrawerProps {
  children: React.ReactNode;
  filterOpen: boolean;
  setFilterOpen: (open: boolean) => void;
}

const FilterDrawer = ({ children, filterOpen, setFilterOpen }: FilterDrawerProps) => {
  const { t } = useTranslation();

  // hide intercom button when filter drawer is open
  useEffect(() => {
    const intercomButton = document.querySelector('[aria-label="Open Intercom Messenger"]');

    if (intercomButton) {
      (intercomButton as HTMLElement).style.display = filterOpen ? 'none' : '';
    }
  }, [filterOpen]);

  return (
    <div
      className={cn(
        'below-app-header fixed inset-y-0 right-0 z-10 w-[22rem] max-w-full overflow-scroll border-l-[1px] border-deepGray-500/[12%] bg-gray-100 shadow-2xl transition-all duration-200',
        filterOpen ? 'right-0' : '-right-[22rem]'
      )}
    >
      <div className="flex h-full flex-col">
        <div className="flex items-center justify-between border-b-[1px] border-deepGray-500/[12%] px-4 py-2">
          <div className="text-lg font-medium">{t('core.filters')}</div>
          <IconButton
            onClick={() => setFilterOpen(false)}
            icon={XmarkIcon}
            name="close"
            size="sm"
            variant="ancillary"
          />
        </div>
        {children}
      </div>
    </div>
  );
};

export default FilterDrawer;
